import { BlobServiceClient } from "@azure/storage-blob";
import { storageConfigs } from "src/storageConfig";
import gatewayAxios from "src/lib/axios";
import { API_SERVICE_BACKEND } from "src/config";
export const uploadFileToAzure = async (file, name, storageType) => {
  try {
    const config = storageConfigs[storageType];

    if (!config) {
      throw new Error(`Invalid storage type: ${storageType}`);
    }

    const { storageAccountUrl, sasToken, containerName } = config;

    const blobServiceClient = new BlobServiceClient(
      `${storageAccountUrl}?${sasToken}`
    );
    const client = blobServiceClient.getContainerClient(containerName);
    const blobClient = client.getBlockBlobClient(name);

    await blobClient.uploadData(file);
    return blobClient.url;
  } catch (error) {
    console.error("Upload failed:", error);
    throw error;
  }
};

// Remove file from Azure Blob Storage
export const removeFileFromAzure = async (fileUrl) => {
  try {
    // client backend api call to remove file from Azure Blob Storage
    const response = await gatewayAxios.delete(`${API_SERVICE_BACKEND}/delete-azure-blob`, {
      params: {
        url: fileUrl,
      },
    });
    return response.data;
  }
  catch (error) {
    console.error("Remove failed:", error);
    throw error;
  }
};
